import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface Demand {
  id: string
  name: string
  flight_date: string
}

export interface SearchDemandsByRegionRequest {
  fields?: string[]
}

export type SearchDemandsByRegionResponse = Demand[]

export async function searchDemandsByRegion(
  regionId: number,
  payload: SearchDemandsByRegionRequest = {},
  options?: AxiosRequestConfig,
): Promise<SearchDemandsByRegionResponse> {
  const { data } = await companiesApi.post<SearchDemandsByRegionResponse>(
    apiRoutes.searchDemandsByRegion(regionId),
    payload,
    options,
  )

  return data
}
